module.exports = __webpack_public_path__ + "img/packages/l3.6556ba.png";